<div class="ca-text-tertiary break-words">{{ label() }}</div>
<div class="ca-text-primary break-words"><ng-content></ng-content></div>
